export const navMenuItems = [
  {
    name: "Home",
    url: "#home",
  },
  {
    name: "About me",
    url: "#about-me",
  },
  {
    name: "Work experience",
    url: "#work-experience",
  },
  {
    name: "Personal projects",
    url: "#side-projects",
  },
  {
    name: `Let's connect`,
    url: "#lets-connect",
  },
  {
    name: "Blog",
    url: "/blogs",
  },
];
